export function toUpperCase(value) {
  if (!value) {
    return '';
  }
  return value[0].toUpperCase() + value.slice(1).toLowerCase();
}

export function isValidObjectId(id) {
  return (
    typeof id === 'string' && id.length === 24 && /^[a-fA-F0-9]{24}$/.test(id)
  );
}

export function getGroupLabel(group, workspaceCustomFields, isTitle = false) {
  const groupings = group?.split('.');

  if (groupings?.length > 1 && group?.includes('customFields') > -1) {
    const cf = workspaceCustomFields?.find((c) => c._id === groupings[1]);
    return cf?.name || '-- field not found --';
  }

  // For standard fields, capitalize first letter
  return group?.charAt(0)?.toUpperCase() + group?.slice(1);
}
